import {isNotNil} from 'ramda-adjunct';

import {getApiDateString, Nullish} from 'shared/web';

import {parseTechnicalInspectionDate} from './parseTechnicalInspectionDate';

/**
 * Converts the check-in/hand-over technical inspection value into the API date string
 * expected by the vehicle state, or null when the value is not usable.
 *
 * Returning null lets the caller skip the vehicle update instead of throwing a
 * RangeError and aborting the whole save.
 */
export function getTechnicalInspectionValidUntil(technicalInspection: string | Nullish) {
  const date = parseTechnicalInspectionDate(technicalInspection);

  return isNotNil(date) ? getApiDateString(date) : null;
}
